/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import styled from 'styled-components';
import Image from 'react-bootstrap/Image';

export const CoverImageStyle: any = {
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundAttachment: 'fixed',
  borderRadius: '30px',
};

export const imageStyle: any = {
  width: '40vw',
  height: '300px',
  objectFit: 'cover',
  borderRadius: '20px',
  cursor: 'pointer',
};

export const CarouselItemContainer: any = {
  marginRight: '20px',
  marginTop: '10px',
  marginBottom: '20px',
};

export const DocumentContainer: any = {
  marginTop: '0px',
  alignSelf: 'center',
  alignItems: 'center',
  justifyContent: 'center',
};

export const Title = styled.h6`
  font-size: 0.8em;
  line-height: 2em;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  @media (max-width: 480px) {
    font-size: 0.8em;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
`;

export const Meta = styled.p`
  font-size: 0.8em;
  color: #8f8f8f;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  @media (max-width: 480px) {
    font-size: 0.7em;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
`;

export const MetaLogo: any = styled(Image)`
  width: 20px;
  height: auto;
  border-radius: 10px;
  object-fit: contain;
  margin-top: -3px;
  padding: 1px;
`;
